<template>
  <div class="PartnerView" v-if="partner && partner.uuid">
    <h1 class="title">
      <api-picture
        style="height: 40px; margin-right: 1ch"
        :picture-id="partner.logo_id"
      ></api-picture
      >{{ partner.name }}
      <router-link
        style="font-size: 12px; position: relative; bottom: 4px;"
        :to="`/partner/edit/${partner.uuid}`"
        ><i class="fa fa-edit"></i> éditer</router-link
      >
    </h1>
    <hr />
    <h3 class="subtitle">Coordonnées :</h3>
    <ul>
      <li>Adresse : {{ partner.address }}</li>
      <li>Site Web : {{ partner.website }}</li>
      <li>Téléphone : {{ partner.telephone }}</li>
    </ul>
    <hr />
    <h3 class="subtitle">Équipe :</h3>
    <div class="tags">
      <div class="tag" v-for="c in partner.contacts" :key="c.uuid">
        <router-link :to="`/contacts/view/${c.uuid}`"
          >{{ c.first_name }}&nbsp;{{ c.last_name }}</router-link
        >
      </div>
    </div>
    <h3 class="subtitle">Projets :</h3>
    <div class="tags">
      <div class="tag" v-for="c in projects" :key="c.uuid">
        <router-link :to="`/projects/view/${c.uuid}`">{{ c.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { types as t, additions as a } from "../../store/actions/partners";
import ApiPicture from "../../components/Form/ApiPicture";

export default {
  name: "PartnerView",
  components: { ApiPicture },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      partner: {},
      loading: false
    };
  },
  computed: {
    projects() {
      return this.partner
        ? this.partner.projects_summary.reduce(
            (acc, proj) => {
              if (!acc.uuids[proj.uuid]) {
                acc.items.push(proj);
                acc.uuids[proj] = 1;
              }
              return acc;
            },
            { items: [], uuids: {} }
          ).items
        : [];
    }
  },
  async mounted() {
    this.partner = await this.$store.dispatch(t.GET_PARTNER_BY_UUID, {
      uuid: this.uuid,
      appends: [a.CONTACTS, a.PROJECTS_SUMMARY]
    });
  }
};
</script>

<style lang="scss">
.PartnerEdit {
}

.PartnerContacts {
  padding: 16px;
  border-radius: 3px;
  margin: 1em 0;
}
</style>
